import { Provider } from "components/language/LanguageContext";
import { LanguageList } from "components/language/LanguageList";

export const Languages = () => {
    return (
        <Provider>
            <LanguageList />
        </Provider>
    );
};
